const DEFAULT_SHOPIFY_HOST = 'vitl.com';

const getShopifyOrigin = () => {
  const configuredHost = process.env.GATSBY_SHOPIFY_HOST || DEFAULT_SHOPIFY_HOST;
  return /^https?:\/\//i.test(configuredHost) ? configuredHost : `https://${configuredHost}`;
};

export const buildShopifyCustomerAccountLoginUrl = (returnPath: string) => {
  const loginUrl = new URL('/customer_authentication/login', getShopifyOrigin());
  loginUrl.searchParams.set('return_to', returnPath);
  return loginUrl.toString();
};
